import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_OPEN_CASES_REPORTS_REQUEST = 'FETCH_OPEN_CASES_REPORTS_REQUEST';
export const FETCH_OPEN_CASES_REPORTS_SUCCESS = 'FETCH_OPEN_CASES_REPORTS_SUCCESS';
export const FETCH_OPEN_CASES_REPORTS_FAILURE = 'FETCH_OPEN_CASES_REPORTS_FAILURE';

export const FETCH_CASE_WORKLOAD_REPORTS_REQUEST = 'FETCH_CASE_WORKLOAD_REPORTS_REQUEST';
export const FETCH_CASE_WORKLOAD_REPORTS_SUCCESS = 'FETCH_CASE_WORKLOAD_REPORTS_SUCCESS';
export const FETCH_CASE_WORKLOAD_REPORTS_FAILURE = 'FETCH_CASE_WORKLOAD_REPORTS_FAILURE';

export const FETCH_CLOSED_CASES_REPORTS_REQUEST = 'FETCH_CLOSED_CASES_REPORTS_REQUEST';
export const FETCH_CLOSED_CASES_REPORTS_SUCCESS = 'FETCH_CLOSED_CASES_REPORTS_SUCCESS';
export const FETCH_CLOSED_CASES_REPORTS_FAILURE = 'FETCH_CLOSED_CASES_REPORTS_FAILURE';
export const FETCH_VIOLATION_REPORTS_REQUEST = 'FETCH_VIOLATION_REPORTS_REQUEST';
export const FETCH_VIOLATION_REPORTS_SUCCESS = 'FETCH_VIOLATION_REPORTS_SUCCESS';
export const FETCH_VIOLATION_REPORTS_FAILURE = 'FETCH_VIOLATION_REPORTS_FAILURE';

export const FETCH_TOTAL_CASES_REPORTS_REQUEST = 'FETCH_TOTAL_CASES_REPORTS_REQUEST';
export const FETCH_TOTAL_CASES_REPORTS_SUCCESS = 'FETCH_TOTAL_CASES_REPORTS_SUCCESS';
export const FETCH_TOTAL_CASES_REPORTS_FAILURE = 'FETCH_TOTAL_CASES_REPORTS_FAILURE';

const baseURL = 'xerce/reports/cases';

export const fetchTotalCaseReport = (params: IReportRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [FETCH_TOTAL_CASES_REPORTS_REQUEST, FETCH_TOTAL_CASES_REPORTS_SUCCESS, FETCH_TOTAL_CASES_REPORTS_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchOpenedCaseReport = (params: IReportRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [FETCH_OPEN_CASES_REPORTS_REQUEST, FETCH_OPEN_CASES_REPORTS_SUCCESS, FETCH_OPEN_CASES_REPORTS_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchCaseWorkloadReport = (params: IReportRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [
      FETCH_CASE_WORKLOAD_REPORTS_REQUEST,
      FETCH_CASE_WORKLOAD_REPORTS_SUCCESS,
      FETCH_CASE_WORKLOAD_REPORTS_FAILURE,
    ],
    hideLoadingWidget: true,
  },
});

export const fetchClosedCaseReport = (params: IReportRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [FETCH_CLOSED_CASES_REPORTS_REQUEST, FETCH_CLOSED_CASES_REPORTS_SUCCESS, FETCH_CLOSED_CASES_REPORTS_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchViolationReport = (params: IReportRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [FETCH_VIOLATION_REPORTS_REQUEST, FETCH_VIOLATION_REPORTS_SUCCESS, FETCH_VIOLATION_REPORTS_FAILURE],
    hideLoadingWidget: true,
  },
});
